import Cookies from 'js-cookie'

interface IData {
  token: string
  expiresOn: string
}

const getDays = (dateString: string) => {
  const currentDate = new Date()
  const passedDate = new Date(dateString)

  const differenceInTime = passedDate.getTime() - currentDate.getTime()

  const differenceInDays = differenceInTime / (1000 * 3600 * 24)

  return Math.ceil(differenceInDays)
}

/**
 * Sets the JWT token and its expiration date in cookies.
 * @param data - The data object containing the token and its expiration date.
 * @param remember - Optional. Specifies whether to remember the token or not. Defaults to false.
 */
const setJwt = (data: IData, remember?: boolean) => {
  const { token, expiresOn } = data
  if (remember) {
    const tokenDays = getDays(expiresOn)
    Cookies.set('jwt', token, { expires: tokenDays })
    Cookies.set('jwtExpire', `${expiresOn}`, { expires: tokenDays })
  } else {
    Cookies.set('jwt', token)
    Cookies.set('jwtExpire', `${expiresOn}`)
  }
}

export default setJwt
